import { Component, OnInit } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { AuthCheckService } from './core/services/auth-check.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  title = 'skye-app';

  constructor(
    iconRegistry: MatIconRegistry,
    sanitizer: DomSanitizer,
    private authCheckService: AuthCheckService
  ) {
    iconRegistry
      .addSvgIcon(
        'angular',
        sanitizer.bypassSecurityTrustResourceUrl('https://0t2.github.io/angular-material-notes/svg/angular.svg')
      )
      .addSvgIconInNamespace(
        'custom-svg',
        'angular',
        sanitizer.bypassSecurityTrustResourceUrl(
          'https://0t2.github.io/angular-material-notes/svg/angular_solidBlack.svg'
        )
      )
      .addSvgIconSetInNamespace(
        'core',
        sanitizer.bypassSecurityTrustResourceUrl('https://0t2.github.io/angular-material-notes/svg/core-icon-set.svg')
      )
      .registerFontClassAlias('fontawesome', 'fa');
  }

  ngOnInit() {
    this.authCheckService.checkAuth$.subscribe();
  }
}
